<template>
  <div>
    <div class="theone">
      <div class="frame_title"></div>
      <Card class="frame_body">
        <Layout>
          <Content :style="{ minHeight: '280px', background: '#555555' }">
            <div v-show="currName == '1-1'">
              <Divider class="blue" orientation="left">课件</Divider>
              <div class="handle">
                <div>
                  <div @click="back" class="goBack"><span><</span>返回</div>
                  <p>{{ sonMsg }}</p>
                </div>
                <div class="handle_right">
                <a @click="handleCourseResFile(sonMsg)" style="width: 140px;height: 30px;" v-if="thisCurse.attachmentUrl&&thisCurse.isZipConvert == 1"><img src="@/assets/courseDownload.png" alt="" style="width:auto;height:.32rem;margin-right:.2rem"/></a>
                <div class="fullScreen" @click="toFullScreen(1)">
                  <span>全屏查看</span>
                </div>
                </div>
              </div>
              <LoadingPage style="height:7.6rem" v-if="loading"></LoadingPage>
              <div class="frame_wrapper" v-else>
                <img src="@/assets/leftArrow.png" title="快捷键:键盘左键" alt="" @click="prevPage" />
                <img src="@/assets/rightArrow.png" title="快捷键:键盘右键" alt="" @click="nextPage" />
                <div style="width:90%;height:750px;margin: 0 auto;margin-top:30px">
                  <PDF v-if="isShowKejian" :page="currentPage" @num-pages="pageCount = $event" @page-loaded="currentPage = $event" @loaded="loadPdfHandler" ref="ifr" :src="KejianPdfUrl + '#toolbar=0'"> </PDF>
                </div>
              </div>
            </div>

            <div v-show="currName == '1-2'">
              <Divider class="blue" orientation="left">教案</Divider>
              <div class="handle">
                <div>
                  <div @click="back" class="goBack"><span><</span>返回</div>
                  <p>{{ sonMsg }}</p>
                </div>
                <div class="handle_right">
                  <Button @click="printJa" v-if="showPrint" type="primary" icon="ios-print">打印</Button>
                  <div class="fullScreen" @click="toFullScreen(2)">
                    <span>全屏查看</span>
                  </div>
                </div>
              </div>
              <LoadingPage style="height:7.6rem" v-if="loading"></LoadingPage>
              <div class="pdf" style="width:70%;margin:20px auto" v-else-if="!loading && isShowJiaoan">
                <!-- <iframe id="iframe2" :src="JiaoanPdfUrl + '#toolbar=0'" ref="ifr2" frameborder="0" width="100%" :height="height" scrolling="auto"></iframe> -->
                <PDF
                  ref="ifr2"
                  width="100%"
                  :height="height"
                  v-for="i in JiaoannumPages"
                  :key="i"
                  :src="JiaoanPdfUrl"
                  :page="i"
                  >
                </PDF>
              </div>
            </div>
            <div v-show="currName == '1-3'">
              <Divider class="blue" orientation="left">学生手册</Divider>
              <div class="handle">
                <div>
                  <div @click="back" class="goBack"><span><</span>返回</div>
                  <p>{{ sonMsg }}</p>
                </div>
                <div class="handle_right">
                  <Button @click="printSc" v-if="showPrint" type="primary" icon="ios-print">打印</Button>
                  <div class="fullScreen" @click="toFullScreen(3)">
                    <span>全屏查看</span>
                  </div>
                </div>
              </div>
              <LoadingPage style="height:80vh" v-if="RenwudanPdfUrl == ''"></LoadingPage>
              <div class="pdf" v-else>
                <iframe id="iframe3" :src="RenwudanPdfUrl + '#toolbar=0'" ref="ifr3" frameborder="0" width="100%" :height="height" scrolling="auto"></iframe>
              </div>
            </div>
            <div v-show="currName == '1-4'" style="background-color: #555555">
              <Divider class="blue" orientation="left">学生视频</Divider>
              <div class="handle">
                <div>
                  <div @click="back" class="goBack"><span><</span>返回</div>
                  <p>{{ sonMsg }}</p>
                </div>
                <div class="fullScreen" @click="toFullScreen(4)">
                  <span>全屏查看</span>
                </div>
              </div>

              <div style="width:100%">
                <div style="width:1000px;height:600px;margin: auto ">
                  <video :src="stuVideoUrL" controls style="width:100%;height:100%" ref="playerStu"></video>
                </div>
              </div>
            </div>
            <div v-show="currName == '1-5'" style="background-color: #555555">
              <Divider class="blue" orientation="left"></Divider>
              <div class="handle">
                <div>
                  <div @click="back" class="goBack"><span><</span>返回</div>
                  <p>{{ sonMsg }}</p>
                </div>
              </div>
            </div>
            <div v-show="currName == '1-6'" style="background-color: #555555">
                <Divider class="blue" orientation="left">教师视频：{{videoNameTeacher}}</Divider>
                <div class="handle">
                <div>
                    <div @click="back" class="goBack"><span><</span>返回</div>
                    <p>{{ sonMsg }} </p>
                </div>
                <div class="fullScreen" @click="toFullScreen(5)">
                    <span>全屏查看</span>
                </div>
                </div>
                <Aliplayer
                :vid="vidTech"
                :playauth="playauthTech"
                :cover="coverTech"
                :format="mp4"
                ref="player"
                class="videoScreen"
                style="margin: 20px auto"
                ></Aliplayer>
            </div>
            <div v-show="currName == '1-61'" style="background-color: #555555">
                <div class="blue" orientation="left">教师视频：{{videoNameTeacher2}}</div>
                <div class="handle">
                <div>
                    <div @click="back" class="goBack"><span><</span>返回</div>
                    <p>{{ sonMsg }}  {{videoNameTeacher2}}</p>
                </div>
                <div class="fullScreen" @click="toFullScreen(5)">
                    <span>全屏查看</span>
                </div>
                </div>
                <Aliplayer
                :vid="vidTech"
                :playauth="playauthTech"
                :cover="coverTech"
                :format="mp4"
                ref="player2"
                class="videoScreen"
                style="margin: 20px auto"
                ></Aliplayer>
            </div>
            <div v-show="currName == '1-62'" style="background-color: #555555">
                <Divider class="blue" orientation="left">教师视频：{{videoNameTeacher3}}</Divider>
                <div class="handle">
                <div>
                    <div @click="back" class="goBack"><span><</span>返回</div>
                    <p>{{ sonMsg }}  {{videoNameTeacher3}}</p>
                </div>
                <div class="fullScreen" @click="toFullScreen(5)">
                    <span>全屏查看</span>
                </div>
                </div>
                <Aliplayer
                :vid="vidTech"
                :playauth="playauthTech"
                :cover="coverTech"
                :format="mp4"
                ref="player3"
                class="videoScreen"
                style="margin: 20px auto"
                ></Aliplayer>
            </div>
            <div v-show="currName == '1-7'||currName == '11-1'" style="background-color: #555555">
              <Divider class="blue" orientation="left"></Divider>
              <div class="handle">
                <div>
                  <div @click="back" class="goBack"><span><</span>返回</div>
                  <p>{{ sonMsg }}</p>
                </div>
              </div>
            </div>
            <div v-show="currName == '1-8'||currName == '1-9'" style="background-color: #555555">
              <Divider class="blue" orientation="left"></Divider>
              <div class="handle">
                <div>
                  <div @click="back" class="goBack"><span><</span>返回</div>
                  <p>{{ sonMsg }}</p>
                </div>
              </div>
            </div>
          </Content>

          <Sider hide-trigger style="max-width: 205px;flex: 0 0 205px;" class="right_slide">
            <Menu active-name="1-1" theme="light" width="auto" :open-names="['1', '2']" @on-select="HandleMenuSelect">
              <!-- @on-select="currName=$event"> -->
              <!-- <Submenu name="1"> -->
              <MenuItem v-show="isShowCourseWare" name="1-1"> <img src="@/assets/courseware.png" alt="" />课&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;件 </MenuItem>
              <MenuItem v-show="isShowTeachPlan" name="1-2"><img src="@/assets/lesson.png" alt="" />教&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;案</MenuItem>
              <MenuItem v-show="isShowWorkOrder" name="1-3"><img src="@/assets/handbook.png" alt="" />学生手册</MenuItem>
              <MenuItem v-show="isShowVeidoStu" name="1-4" v-if="courseType === 1"><img src="@/assets/video.png" alt="" />学生视频</MenuItem>
              <MenuItem name="1-7" v-if="courseType === 2"><img src="@/assets/video.png" alt="" />学生互动视频</MenuItem>
              <MenuItem v-show="isShowVeidoTech" name="1-6"><img src="@/assets/video.png" alt="" />{{videoNameTeacher}}</MenuItem>
               <MenuItem v-show="isShowVeidoTech2" name="1-61"
                ><img src="@/assets/video.png" alt="" /> {{videoNameTeacher2}}</MenuItem
                >
                <MenuItem v-show="isShowVeidoTech3" name="1-62"
                ><img src="@/assets/video.png" alt="" /> {{videoNameTeacher3}}</MenuItem
                >
              <MenuItem v-show="isShowMaterial" name="1-5">
                <img src="@/assets/create.png" alt="" />
                <router-link
                  :to="{
                    path: '../peixun/showScratch',
                    query: {
                      createrName: this.createrName,
                      createBy: this.createBy,
                      materialUrl: this.materialUrl,
                      ossPath: ''
                    }
                  }"
                  target="_blank"
                >
                  开始创作
                </router-link>
              </MenuItem>
              <MenuItem v-show="isShowExMaterial" name="1-8">
                <img src="@/assets/exMaterial.png" alt="" />
                <router-link
                  :to="{
                    path: '../peixun/showScratch',
                    query: {
                      createrName: this.createrName,
                      createBy: this.createBy,
                      materialUrl: this.exMaterialUrl,
                      ossPath: ''
                    }
                  }"
                  target="_blank"
                >
                  拓展创作
                </router-link>
              </MenuItem>
              <MenuItem v-show="isShowStep2StepProgram" name="1-1">
                <img src="@/assets/codelab.png" alt="" />
                <router-link
                  :to="{
                    path: '/task-customer',
                    query: {
                      courseId: this.step2StepProgramId,
                      name: this.courseName,
                    },
                  }"
                  target="_blank"
                >
                    编程实验室
                </router-link>
              </MenuItem>
              <MenuItem v-show="isShowAItools" name="1-5">
                <img src="@/assets/aitools.png" alt="" />
                
                <a :href="this.aiToolsUrl" target="_blank">
                  AI 工具箱
                </a>
                </MenuItem>
              <MenuItem v-show="isShowSyMaterial" name="1-9">
                <img src="@/assets/juqing.png" alt="" />
                <router-link
                  :to="{
                    path: '../peixun/showScratch',
                    query: {
                      createrName: this.createrName,
                      createBy: this.createBy,
                      materialUrl: this.syMaterialUrl,
                      ossPath: ''
                    }
                  }"
                  target="_blank"
                >
                  剧情作品
                </router-link>
              </MenuItem>
            </Menu>
            <div v-if="isShowAttachment" class="appendix">
              <a :href="attachmentUrl"><img src="@/assets/downAppendix.png" alt=""/></a>
            </div>
          </Sider>
        </Layout>
      </Card>
    </div>
    <div class="aaliplayr" v-if="showInteraction">
      <Aliplayer
        :vid="vid"
        :playauth="playauth"
        :cover="cover"
        format="mp4"
        ref="playerInteraction"
        class="videoScreen"
        @ended="endedPlayer"
        v-if="showAliplayer"
        style="margin: 0 auto;width:100%;height:100%"
      ></Aliplayer>
      <div class="scratchIframe" v-if="showScratch">
        <iframe id="iframe" src="/scratch-gui/" frameBorder="0" width="100%" height="100%" scrolling="auto"></iframe>
      </div>
      <!-- fullscreen -->
      <!-- 习题闯关弹窗 -->
      <Modal v-model="showExam" :title="examTitType" class="examMoadal" width="700">
        <div class="previewExercises">
          <div v-if="examInfo.examType === 'single'">
            <div class="exerciseTil" v-html="examInfo.content"></div>
            <div style="margin-left:70px" v-if="examInfo.examType === 'single'" class="single">
              <Radio-group v-model="singleAnwer" vertical>
                <Radio label="A"><span v-html="examInfo.choiceA"></span></Radio>
                <Radio label="B"><span v-html="examInfo.choiceB"></span></Radio>
                <Radio label="C"><span v-html="examInfo.choiceC"></span></Radio>
                <Radio label="D"><span v-html="examInfo.choiceD"></span></Radio>
              </Radio-group>
            </div>
          </div>
          <div v-else-if="examInfo.examType === 'multiple'">
            <div class="exerciseTil" v-html="examInfo.content"></div>
            <div style="margin-left:70px" v-if="examInfo.examType === 'multiple'">
              <Checkbox-group v-model="multipleAnswer" vertical class="multiple">
                <Checkbox label="A"><span v-html="examInfo.choiceA"></span></Checkbox>
                <Checkbox label="B"><span v-html="examInfo.choiceB"></span></Checkbox>
                <Checkbox label="C"><span v-html="examInfo.choiceC"></span></Checkbox>
                <Checkbox label="D"><span v-html="examInfo.choiceD"></span></Checkbox>
              </Checkbox-group>
            </div>
          </div>
          <div v-else-if="examInfo.examType === 'judge'">
            <div class="exerciseTil" v-html="examInfo.content"></div>
            <div style="margin-left:70px" v-if="examInfo.examType === 'judge'" class="jugle">
              <Radio-group v-model="jugleAnswer" vertical>
                <Radio label="T">
                  <span>A、正确</span>
                </Radio>
                <Radio label="F">
                  <span>B、错误</span>
                </Radio>
              </Radio-group>
            </div>
          </div>
        </div>
        <div slot="footer">
          <!-- <Button type="text" @click="showExam = false">取消</Button> -->
          <Button :loading="submitLoading" @click="submit(currentInteract.id, examInfo.examType)">提交</Button>
        </div>
      </Modal>
    </div>
    <div class="allTaskBtn" @click="toShowTask" v-if="!showTask && courseType === 2 && showInteraction">全部任务</div>
    <Drawer title="查看任务" class="drawerModal" closable v-model="showTask" width="400">
      <div class="closeDrawer" @click="closeDrawer">关闭</div>
      <Button @click="drawBack" class="backBtn" size="large">退出挑战</Button>
      <Timeline>
        <Timeline-item v-for="(item, i) in interactList" :key="i">
          <!-- <Icon type="ios-paw" slot="dot" style="color:#fff;font-size:20px" v-if="idx===i"></Icon> -->
          <div :class="[{ videoPro: true }, { gray: item.finish === 0 }]" @click="toDetail(item)" v-if="item.materialType === 'vedio'">
            <div :class="[{ videoIcon: true }, { leftIcon: true }, { grayIcon: item.finish === 0 }]">
              <img src="@/assets/Ibofang.png" alt="" v-if="item.finish" />
              <img src="@/assets/iLock.png" alt="" v-else />
            </div>
            <div class="taskName">{{ item.name }}</div>
          </div>
          <div v-if="item.materialType === 'scratch'" @click="toDetail(item)">
            <div :class="[{ videoPro: true }, { gray: item.finish === 0 }]">
              <div :class="[{ scratchIcon: true }, { leftIcon: true }, { grayIcon: item.finish === 0 }]">
                <img src="@/assets/Ijimu.png" alt="" v-if="item.finish" />
                <img src="@/assets/iLock.png" alt="" v-else />
              </div>
              <div class="taskName">{{ item.name }}</div>
            </div>
          </div>
          <div :class="[{ videoPro: true }, { gray: item.finish === 0 }]" v-if="item.materialType === 'exam'" @click="toDetail(item)">
            <div :class="[{ examIcon: true }, { leftIcon: true }, { grayIcon: item.finish === 0 }]">
              <img src="@/assets/Iedit.png" alt="" v-if="item.finish" />
              <img src="@/assets/iLock.png" alt="" v-else />
            </div>
            <div class="taskName">{{ item.name }}</div>
          </div>
        </Timeline-item>
      </Timeline>
    </Drawer>
    <!-- 闯关闯关弹窗 -->
    <Modal v-model="successModal" class="successModal">
      <img src="@/assets/taskSuccess.png" alt="" />
      <div slot="footer"></div>
    </Modal>
    <!-- 通关闯关弹窗 -->
    <Modal v-model="overModal" class="successModal">
      <img src="@/assets/successOver.png" alt="" />
      <div slot="footer"></div>
    </Modal>
    <Drawer title="课程资料" class="uploadCodeModal" closable v-model="showCourseResFile" width="1510">
      <h2 style="font-size:24px">{{sonMsg}}-课程资料</h2>
      <Button type="primary" style="margin-top:10px" @click="buildCourseResFileZip"  :loading="buildZipLoading">{{buildZipTitle}}</Button>
      <div style="width: 95%;height: 2px;background-color: #eee;margin: 10px;"></div>
      <div style="width:1450px;">
        <p style="margin-bottom: 10px;">
          
          <span v-if="breadcrumbList.length > 0" @click="backPreviousCourseResFile">
            <span class="clickTitleName">返回上一级</span>
            <span class="clickTitleNameSep">|</span>
          </span> 

          <span v-if="breadcrumbList.length > 0" class="clickTitleName" @click="toCourseResFileFolder('/',0)">全部文件</span>
          <span v-else class="noClickTitleName">全部文件</span>

          <span v-for="(item,index) in breadcrumbList" :key="index">
            <span class="clickTitleNameSep">></span>
            <span v-if="index < breadcrumbList.length-1" class="clickTitleName" @click="toCourseResFileFolder(item.path,index)">{{item.name}}</span>
            <span v-else class="noClickTitleName">{{item.name}}</span>
          </span>
        </p>
        
        <div style="width:1300px;min-height: 100px;display: inline-block;float: left; ">
          
          <div v-if="fileList.length == 0" style="text-align: center;margin-top: 200px;">
            <div style="margin: 0 auto;width: 20px;" v-if="getFileStatus"><Spin size="large"></Spin></div>
            <div v-else>
              <img src="@/assets/file/nofile.png" style="width: 20%;"/>
              <p>当前列表为空</p>
            </div>
          </div>
          <div v-else v-for="(item,index) in fileList" :key="index" class="fileItem"  @mouseenter="showDetails(index)" @mouseleave="hideDetails(index)" @mousemove="updateXY" >
            <div class="fileDownloadBtn" ><Icon v-if="item.type.toLowerCase() == 'file'" type="ios-download-outline" color="#06a7ff" @click="downloadIndividualFiles(item.url,item.name)"></Icon></div>
            <div @click="toCourseResFileFolder(item.path,index,item.name,item.typeStatus,item.url)">
            <img src="@/assets/file/a-filefolder_yellow.png" v-if="item.type.toLowerCase() == 'folder'" alt="" style="width:80%;" />
            <img src="@/assets/file/python.png" v-else-if="item.type.toLowerCase() == 'file'&&item.fileType.toLowerCase() == 'py'" alt="" style="width:80%;" />
            <img src="@/assets/file/a-ziprar.png" v-else-if="item.type.toLowerCase() == 'file'&&item.fileType.toLowerCase() == 'zip'" alt="" style="width:80%;" />
            <img src="@/assets/file/a-ziprar.png" v-else-if="item.type.toLowerCase() == 'file'&&item.fileType.toLowerCase() == 'rar'" alt="" style="width:80%;" />
            <img src="@/assets/file/gif.png" v-else-if="item.type.toLowerCase() == 'file'&&item.fileType.toLowerCase() == 'gif'" alt="" style="width:80%;" />
            <img src="@/assets/file/img.png" v-else-if="item.type.toLowerCase() == 'file'&&item.fileType.toLowerCase() == 'img'" alt="" style="width:80%;" />
            <img src="@/assets/file/jpg.png" v-else-if="item.type.toLowerCase() == 'file'&&item.fileType.toLowerCase() == 'jpg'" alt="" style="width:80%;" />
            <img src="@/assets/file/png.png" v-else-if="item.type.toLowerCase() == 'file'&&item.fileType.toLowerCase() == 'png'" alt="" style="width:80%;" />
            <img src="@/assets/file/mp4.png" v-else-if="item.type.toLowerCase() == 'file'&&item.fileType.toLowerCase() == 'mp4'" alt="" style="width:80%;" />
            <img src="@/assets/file/bmp.png" v-else-if="item.type.toLowerCase() == 'file'&&item.fileType.toLowerCase() == 'bmp'" alt="" style="width:80%;" />
            <img src="@/assets/file/mov.png" v-else-if="item.type.toLowerCase() == 'file'&&item.fileType.toLowerCase() == 'avi'" alt="" style="width:80%;" />
            <img src="@/assets/file/mov.png" v-else-if="item.type.toLowerCase() == 'file'&&item.fileType.toLowerCase() == 'wmv'" alt="" style="width:80%;" />
            <img src="@/assets/file/mov.png" v-else-if="item.type.toLowerCase() == 'file'&&item.fileType.toLowerCase() == 'mpg'" alt="" style="width:80%;" />
            <img src="@/assets/file/mov.png" v-else-if="item.type.toLowerCase() == 'file'&&item.fileType.toLowerCase() == 'mpeg'" alt="" style="width:80%;" />
            <img src="@/assets/file/mov.png" v-else-if="item.type.toLowerCase() == 'file'&&item.fileType.toLowerCase() == 'mov'" alt="" style="width:80%;" />
            <img src="@/assets/file/mov.png" v-else-if="item.type.toLowerCase() == 'file'&&item.fileType.toLowerCase() == 'rm'" alt="" style="width:80%;" />
            <img src="@/assets/file/mov.png" v-else-if="item.type.toLowerCase() == 'file'&&item.fileType.toLowerCase() == 'ram'" alt="" style="width:80%;" />
            <img src="@/assets/file/mov.png" v-else-if="item.type.toLowerCase() == 'file'&&item.fileType.toLowerCase() == 'swf'" alt="" style="width:80%;" />
            <img src="@/assets/file/mov.png" v-else-if="item.type.toLowerCase() == 'file'&&item.fileType.toLowerCase() == 'flv'" alt="" style="width:80%;" />
            <img src="@/assets/file/music.png" v-else-if="item.type.toLowerCase() == 'file'&&item.fileType.toLowerCase() == 'mp3'" alt="" style="width:80%;" />
            <img src="@/assets/file/music.png" v-else-if="item.type.toLowerCase() == 'file'&&item.fileType.toLowerCase() == 'wma'" alt="" style="width:80%;" />
            <img src="@/assets/file/music.png" v-else-if="item.type.toLowerCase() == 'file'&&item.fileType.toLowerCase() == 'aac'" alt="" style="width:80%;" />
            <img src="@/assets/file/music.png" v-else-if="item.type.toLowerCase() == 'file'&&item.fileType.toLowerCase() == 'ogg'" alt="" style="width:80%;" />
            <img src="@/assets/file/music.png" v-else-if="item.type.toLowerCase() == 'file'&&item.fileType.toLowerCase() == 'mpc'" alt="" style="width:80%;" />
            <img src="@/assets/file/music.png" v-else-if="item.type.toLowerCase() == 'file'&&item.fileType.toLowerCase() == 'flac'" alt="" style="width:80%;" />
            <img src="@/assets/file/music.png" v-else-if="item.type.toLowerCase() == 'file'&&item.fileType.toLowerCase() == 'ape'" alt="" style="width:80%;" />
            <img src="@/assets/file/music.png" v-else-if="item.type.toLowerCase() == 'file'&&item.fileType.toLowerCase() == 'wv'" alt="" style="width:80%;" />
            <img src="@/assets/file/music.png" v-else-if="item.type.toLowerCase() == 'file'&&item.fileType.toLowerCase() == 'wav'" alt="" style="width:80%;" />
            <img src="@/assets/file/txt.png" v-else-if="item.type.toLowerCase() == 'file'&&item.fileType.toLowerCase() == 'txt'" alt="" style="width:80%;" />
            <img src="@/assets/file/pdf.png" v-else-if="item.type.toLowerCase() == 'file'&&item.fileType.toLowerCase() == 'pdf'" alt="" style="width:80%;" />
            <img src="@/assets/file/file.png" v-else alt="" style="width:80%;" />
            <p class="fileName">{{item.name}}</p>
            </div>
            <div v-if="item.isDetailsVisible" class="details"  :style="positionStyle">
              <p>名称：{{item.name}}</p>
              <p>大小：{{item.size?formatFileSize(item.size):'-'}}</p>
              <p>修改时间：{{item.lastModified?timestampToDate(item.lastModified):'-'}}</p>
            </div>
          </div>
        </div>
      </div>
    </Drawer>
    <Modal v-model="previewModel" width="1000"  :title="previewTitle" class="uploadModel1" @on-cancel="cancelpreviewModel">
        <div style="display:inline-block;width:870px"><h3 style="display:inline;">{{previewModelData.name}}</h3><span v-if = "previewModelData.type == 'code'" style="color:#007ACC;cursor:pointer;margin-left:20px" @click="copy">代码复制</span></div>
        <div style="width:900px;height:700px">
          <div style="width:100%;text-align: center;">
            <img width="80%" v-if = "previewModelData.type == 'img'" :src="previewModelData.url"/>
          </div>
          <mavon-editor 
            v-if = "previewModelData.type == 'md'"
            v-model="codes" 
            ref="md" 
            :subfield="subfield"
            defaultOpen='preview'
            :toolbarsFlag="toolbarsFlag"
            :editable="editable"
            :scrollStyle="scrollStyle"
            style="min-height: 600px"
        />
          <!-- <codemirror v-model="codes" :options="options"></codemirror> -->
          <codemirror v-if = "previewModelData.type == 'code'"  ref="myCm" v-model="codes" :options="cmOptions" class="code" ></codemirror>
          <div style="width:100%;text-align: center;padding-top: 250px;" v-if = "previewModelData.type == 'audio' && previewModel"><audio :src="previewModelData.url" controls="controls"></audio></div>
          <div style="width:100%;text-align: center;padding-top: 25px;" v-if = "previewModelData.type == 'video' && previewModel"><video :src="previewModelData.url" width="800" height="600" controls="controls"></video></div>
        </div>
        <div slot="footer">
        </div>
    </Modal>
  </div>
</template>
<script>
import {codemirror} from 'vue-codemirror'
import 'codemirror/lib/codemirror.css'
// 引入主题,配置后生效
import 'codemirror/theme/rubyblue.css'
//引入语言,配置后生效
import 'codemirror/mode/sql/sql.js'
import 'codemirror/mode/python/python.js'
// import { codemirror } from 'vue-codemirror'
// import 'codemirror/lib/codemirror.css'
// import 'codemirror/theme/darcula.css'
// import 'codemirror/addon/fold/foldgutter.css'
// import 'codemirror/addon/hint/show-hint.css'
// import 'codemirror/addon/lint/lint.css'

// require('codemirror/addon/comment/comment.js')
// require('codemirror/addon/selection/active-line.js')
// require('codemirror/keymap/sublime.js')

// require('codemirror/addon/hint/show-hint.js')
// require('codemirror/mode/python/python.js')

// require('codemirror/addon/fold/foldcode.js')
// require('codemirror/addon/fold/foldgutter.js')
// require('codemirror/addon/fold/brace-fold.js')
// // require('codemirror/addon/fold/xml-fold.js')
// require('codemirror/addon/fold/indent-fold.js')
// // require('codemirror/addon/fold/markdown-fold.js')
// require('codemirror/addon/fold/comment-fold.js')
// require('codemirror/addon/edit/closebrackets.js')
// require('codemirror/addon/edit/matchbrackets.js')
// 2020-08-27 在武总的要求下禁止打印下载
import LoadingPage from '@/views/my-components/loading'
import Aliplayer from '@/views/my-components/VueAliplayer'
import OSS from 'ali-oss'
import PDF from 'vue-pdf'
import { postRequest, blobRequest, getRequest } from '@/libs/axios'
import util from '@/libs/util'
export default {
  name: 'showCourse-components',
  components: {
    Aliplayer,
    LoadingPage,
    PDF,codemirror
  },
  props: {
    sonMsg: {
      type: String,
      default: null
    },
    currentId: {
      type: String,
      default: null
    },
    courseId: {
      type: String,
      default: null
    },
    courseType: {
      type: Number,
      default: null
    },
    interactiveVideoId: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      mp4:'mp4',
      subfield: false,// 单双栏模式
      editable: true,
      toolbarsFlag: false,
      scrollStyle: true,
      currName: '1-1',
      processModalVisible: false,
      thisCurse: {},
      icon: '',
      picUrl: '',
      // vedioUrl: "http://ceshi-bucket-in.oss-cn-hangzhou.aliyuncs.com/6cc1f6909edf42ccad901558db3dbd33.mp4",
      vedioUrl: '',
      stuVideoUrL: '',
      vidTech: '',
      playauthTech: '',
      coverTech: '',
      processLoading: false,
      height: '525px',
      KejianPdfUrl: '',
      JiaoanPdfUrl: '',
      jiaoanPdf2: '',
      RenwudanPdfUrl: '',
      KejiannumPages: 1,
      JiaoannumPages: 1,
      RenwudannumPages: 1,
      KejianHavedLoad: false,
      RenwudanHavedLoad: false,
      JiaoanHavedLoad: false,
      VedioHavedLoad: false,
      activeIndex: 0,
      materialUrl: '',
      exMaterialUrl: '',
      syMaterialUrl: '',
      createrName: '',
      createBy: '',
      showPrint: false,
      title: '',
      flag: false,
      courseName:"",
      step2StepProgramId:"",
      isShowCourseWare: false,
      isShowTeachPlan: false,
      isShowWorkOrder: false,
      isShowVeidoStu: false,
      isShowVeidoTech: false,
      isShowMaterial: false,
      isShowAttachment: false,
      attachmentUrl: '',
      numPages: 0,
      currentPage: 0,
      // ---------------------------
      interactList: [], //素材列表
      currentInteract: {}, //当前素材
      playauth: '',
      vid: '',
      showTask: false,
      cover: '',
      showExam: false,
      showScratch: false,
      showAliplayer: true,
      events: {
        receiveMessageFromParent: async function(event) {
          if (document.getElementById('iframe')) {
            var ifwind = document.getElementById('iframe').contentWindow
            switch (event.data.DYType) {
              case 'menuOk':
                this.$vue.showAliplayer = false
                // if(this.$vue.defaultOssPath.length){
                var postData = {
                  DYType: 'opusData',
                  // 'DYOpusData': {materialPath:this.$vue.defaultOssPath[0]},
                  DYOpusData: { materialPath: this.$vue.ossPath },
                  DYShowScoreButton: false,
                  DYShowSaveButton: false,
                  DYIsDesktop: false,
                  DYFrom: 'xbz',
                  DYCanManageFiles: false,
                  DYShowSubmitButton: false
                }
                ifwind.postMessage(postData, '*')
                // }
                break
              case 'getDownToken':
                let dirPath = event.data.DyDirPath
                const res1 = await getRequest(
                  '/v3/student/getOpusPathFormAliOss',
                  {
                    ossPath: this.$vue.ossPath,
                    dirPath: 'materials'
                  },
                  true
                )
                if (res1.success) {
                  const postData = {
                    DYType: 'aliStsData',
                    downLoadUrl: res1.result.downLoadUrl,
                    DYLoadType: event.data.DYLoadType
                  }
                  ifwind.postMessage(postData, '*')
                }
                break
              case 'nextGo':
                // console.log("闯关成功");
                this.$vue._handleSuccess()
                break
            }
          }
        },
        initScore: 0,
        score: 0,
        DyOssPath: '',
        showScoreButton: false,
        DYShowSaveButton: false
      },
      isShowAItools:false,
      aiToolsUrl:'',
      isShowVeidoTech: false,
      isShowVeidoTech2: false,
      isShowVeidoTech3: false,
      videoNameTeacher:'',
      videoNameTeacher2:'',
      videoNameTeacher3:'',
      singleAnwer: '',
      multipleAnswer: [],
      jugleAnswer: '',
      successModal: false,
      finished: 0, //此节互动课程是否结束 0未  1结束
      ossPath: '',
      examInfo: {},
      examTitType: '',
      noNext: 0, // 判断是否有下一个（最后一个）0 有  1没有
      overModal: false,
      idx: 3,
      submitLoading: false,
      loading: false,
      showInteraction: false,
      isShowExMaterial: false,
      isShowSyMaterial: false,
      fileBack: '',
      isShowJiaoan: false,
      isShowKejian: false,
      showCourseResFile:false,
      breadcrumbList:[],
      lastPath:'',
      getFileStatus:false,
      fileList:[],
      buildZipLoading:false,
      buildZipTitle:"一键打包下载",
      positionStyle:{top:'180px',left:'0px',zIndex:'9999'},
      lastPath:"",
      codes:'',

      previewModelData:{},
      previewModel:false,
      previewTitle:"",
      //需编辑和显示的内容
      // 默认配置
      options: {
        tabSize: 2, // 缩进格式
        theme: 'rubyblue', // 指定主题，对应主题库 JS 需要提前引入
        lineNumbers: true, // 是否显示行号
        //指定语言类型,如果需要编辑和显示其他语言,需要import语言js然后修改此配置
        mode: 'sql',
        line: true,
        styleActiveLine: true, // 高亮选中行
        //是否为只读,如果为"nocursor" 不仅仅为只读 连光标都无法在区域聚焦
        readOnly: true,
        hintOptions: {
          completeSingle: true // 当匹配只有一项的时候是否自动补全
        }
      },
    }
  },
  //   props: ["sonMsg", "currentId", "courseId"],
  watch: {
    // 监听任务栏的显示
    showTask(curVal, oldVal) {
      if (this.showInteraction && this.showAliplayer && curVal && this.$refs.playerInteraction !== 'undefind') {
        this.$refs.playerInteraction.pause()
      } else if (this.showInteraction && this.showAliplayer && !curVal && this.$refs.playerInteraction !== 'undefind') {
        this.$refs.playerInteraction.play()
      }
    }
  },
  methods: {
        // 复制
    copy() {
      try {
        // 创建textArea
        const textarea = document.createElement('textarea');//不会保留文本格式
        //如果要保留文本格式，比如保留换行符，或者多行文本，可以使用  textarea 标签，再配和模板字符串 ` `
        //const input = document.createElement('textarea')
        // 将想要复制的值
        textarea.value = this.codes;;
        // 页面底部追加输入框
        document.body.appendChild(textarea);
        // 选中输入框
        textarea.select();
        // 执行浏览器复制命令
        document.execCommand('Copy');
        // 弹出复制成功信息
        //this.$message.success('复制成功');
        // 复制后移除输入框
        textarea.remove();
        this.$Message.info('复制成功');
        alert("复制成功")
      } catch (error) {
        alert("您的浏览器不支持此操作")
        this.$Message.info('您的浏览器不支持此操作');
      }
    },
    cancelpreviewModel(){
      this.previewModel = false;
      this.previewTitle = "";
    },
    downloadIndividualFiles(url, fileName){
      fetch(url)
      .then(res => res.blob())
      .then(blob => {
          const a = document.createElement("a");
          const objectUrl = window.URL.createObjectURL(blob);
          a.download = fileName;
          a.href = objectUrl;
          a.click();
          window.URL.revokeObjectURL(objectUrl);
          a.remove();
      })
    },
    updateXY(event){
    },
    downloadFile(url, fileName) {
      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    async buildCourseResFileZip(){
      this.buildZipLoading = true
      this.buildZipTitle = "正在打包中..."
      this.$Loading.start();
      this.downloadFile(this.thisCurse.attachmentUrl, this.thisCurse.courseName+"-课程资料");
      this.$Loading.finish();
      this.buildZipLoading = false
      this.buildZipTitle = "一键打包下载"
      return
      
    },
    toCourseResFileFolder(path,index,name,typeStatus,url){
      debugger
        if(typeStatus == 0){
          var codePattern = /(\.py|\.cpp|\.c|\.java|\.conf|\.js|\.vue|\.html|\.txt)$/i;
          var imgPattern = /(\.jpg|\.jpeg|\.png|\.gif)$/i;
          var audioPattern = /(\.mp3|\.wma|\.aac|\.ogg|\.mpc|\.flac|\.ape|\.wv|\.wav)$/i;
          var videoPattern = /(\.mp4|\.avi|\.wmv|\.mpeg|\.mov|\.rm|\.ram|\.swf|\.flv)$/i;
          var mdPattern = /(\.md)$/i;

            if(codePattern.test(name.toLowerCase())){
                debugger
                fetch(url,{cache:'no-cache'}).then(response => {        
                  response.text().then(text => {
                     this.previewModel= true;
                     this.previewModelData ={
                      name,
                      type :"code",
                      url
                    }
                    this.codes = text
                  })
                })
                .catch(e => {
                  alert(e) // eslint-disable-line no-alert
                })
            }else if(imgPattern.test(name.toLowerCase())){
                this.previewModel= true;
                this.previewModelData ={
                  name,
                  type :"img",
                  url
                }
            }else if(audioPattern.test(name.toLowerCase())){
                this.previewModel= true;
                this.previewModelData ={
                  name,
                  type :"audio",
                  url
                } 
            }
            else if(videoPattern.test(name.toLowerCase())){
                this.previewModel= true;
                this.previewModelData ={
                  name,
                  type :"video",
                  url
                }
                
            }else if(mdPattern.test(name.toLowerCase())){
                fetch(url,{cache:'no-cache'}).then(response => {        
                  response.text().then(text => {
                     this.previewModel= true;
                     this.previewModelData ={
                      name,
                      type :"md",
                      url
                    }
                    this.codes = text
                  })
                })
                .catch(e => {
                  alert(e) // eslint-disable-line no-alert
                })
            }
            return
        }
        //1,构建面包屑
        console.log(path)
        if(path == '/'){
          this.breadcrumbList = []
        }else{
          let breadcrumbIndex = this.breadcrumbList.findIndex(i =>i.path === path)
          if( breadcrumbIndex == -1 ){
            let breadcrumb ={
              path,name
            }
            this.breadcrumbList.push(breadcrumb)
          }else{
            this.breadcrumbList = this.breadcrumbList.slice(0, breadcrumbIndex+1);
          }
        }
        //2,查询目录展示
        this.getResFileList(path)
    },
    backPreviousCourseResFile(){
      let breadcrumb = this.breadcrumbList[this.breadcrumbList.length -2];
      if(breadcrumb){
        this.breadcrumbList = this.breadcrumbList.slice(0, this.breadcrumbList.length-1);
        this.getResFileList(breadcrumb.path)
      }else{
        this.breadcrumbList = [];
        this.getResFileList("/");
      }
      
    },
    timestampToDate(timestamp) {
      // 创建一个新的Date对象，使用时间戳作为参数（毫秒）
      const date = new Date(Number(timestamp));
      // 获取年、月、日等属性并格式化输出
      const year = date.getFullYear();
      const month = date.getMonth() + 1; // 月份从0开始，所以需要+1
      const day = date.getDate();
      const hours = date.getHours();
      const minutes = date.getMinutes();
      const seconds = date.getSeconds();

      // 使用字符串模板或三元运算符等，根据需要格式化输出日期和时间
      const formattedDate = `${year}-${month < 10 ? '0' + month : month}-${day < 10 ? '0' + day : day} ${hours}:${minutes}:${seconds}`;

      return formattedDate;
    },
    formatFileSize(bytes) {
      const units = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
      let size = bytes;
      let unitIndex = 0;

      while (size >= 1024 && unitIndex < units.length - 1) {
        size /= 1024;
        unitIndex++;
      }

      // 保留两位小数，四舍五入
      size = Math.round(size * 100) / 100;

      return `${size} ${units[unitIndex]}`;
    },
    showDetails(index) {
      this.fileList[index].isDetailsVisible = true;
    },
    hideDetails(index) {
      this.fileList[index].isDetailsVisible = false;
    },
    handleCourseResFile(title){
      this.showCourseResFile = true
      let courseDetailId = this.currentId;
      this.breadcrumbList = []
      this.getResFileList("/",courseDetailId);
    },
    async getResFileList(path,courseDetailId){
      this.lastPath = path;
      this.getFileStatus = true;
      this.fileList = [];
      let res = await getRequest(
        '/v3/student/resourceFile/getResourceFile',
        {
        courseDetailId: this.currentId,
        path
      },
        false
      )
      if (res.success) { 
        let list = res.result.fileList
        list.sort((a, b) => b.typeStatus - a.typeStatus);
        this.fileList = list 
        console.log(this.fileList);
        console.log(this.fileList.length);
        this.getFileStatus = false;
      }else{
        this.getFileStatus = false;
      }
    },
    drawBack() {
      this.showInteraction = false
      this.showTask = false
      this.examMoadal = false
    },
    // pdf加载时
    loadPdfHandler(e) {
      this.currentPage = 1 // 加载的时候先加载第一页
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--
      }
    },
    nextPage() {
      if (this.currentPage < this.pageCount) {
        this.currentPage++
      }
    },
    toFullScreen(status) {
      let path, type, vid, playauth, cover, stuCode
      switch (status) {
        case 1:
          type = 'pdf'
          path = this.KejianPdfUrl
          stuCode = 0
          break
        case 2:
          type = 'pdf'
          path = this.jiaoanPdf2
          stuCode = 0
          break
        case 3:
          type = 'pdf'
          path = this.RenwudanPdfUrl
          stuCode = 1
          break
        case 4:
          if (this.$refs.playerStu) {
            this.$refs.playerStu.pause()
          }
          type = 'video'
          path = this.stuVideoUrL
          break
        case 5:
          type = 'aliPlayer'
          if (this.$refs.player) {
            this.$refs.player.pause()
          }
          vid = this.vidTech
          playauth = this.playauthTech
          cover = this.coverTech
          break
      }

      let routeData = this.$router.resolve({
        name: 'fullScreenPdf',
        query: { id: this.currentId, path, type, vid, playauth, cover, stuCode }
      })
      window.open(routeData.href, '_blank')
    },
    videoFullScreen() {
      var de = document.getElementsByClassName('videoScreen')[0]
      if (de.requestFullscreen) {
        de.requestFullscreen()
      } else if (de.mozRequestFullScreen) {
        de.mozRequestFullScreen()
      } else if (de.webkitRequestFullScreen) {
        de.webkitRequestFullScreen()
      }
    },
    back() {
      this.$emit('sonBool')
    },
    async init() {
      // const query = this.$route;
      let res = await postRequest(
        '/v3/platform/course/getCourseDetailPageListDetail',
        {
          courseDetailId: this.currentId,
          courseId: this.courseId
        },
        false
      )
      if (res.success) {
        if (res.result.total > 0) {
          this.thisCurse = res.result.list[0];
          if (this.thisCurse.step2StepProgramId && this.thisCurse.step2StepProgramId != "" && this.thisCurse.step2StepProgramId != "null") {
            this.isShowStep2StepProgram = true;
            this.currName = "11-1";
            this.step2StepProgramId = this.thisCurse.step2StepProgramId
            this.courseName = this.thisCurse.courseName
          } else {
            this.isShowStep2StepProgram = false;
          }
          if(this.thisCurse.aiToolsUrl){
            this.isShowAItools = true
            this.aiToolsUrl = this.thisCurse.aiToolsUrl
          }
          if (this.thisCurse.materialUrl && this.thisCurse.materialUrl != '') {
            this.isShowMaterial = true
            this.currName = '1-5'
          } else {
            this.isShowMaterial = false
          }
          if (this.thisCurse.exMaterialUrl && this.thisCurse.exMaterialUrl != '') {
            this.isShowExMaterial = true
            this.currName = '1-8'
          } else {
            this.isShowExMaterial = false
          }
          debugger
          if (this.thisCurse.syMaterialUrl && this.thisCurse.syMaterialUrl != '') {
            this.isShowSyMaterial = true
            this.currName = '1-9'
          } else {
            this.isShowSyMaterial = false
          }

          if (this.thisCurse.videoUrlStudent && this.thisCurse.videoUrlStudent != '') {
            this.isShowVeidoStu = true
            this.currName = '1-4'
          } else {
            this.isShowVeidoStu = false
          }
          if (this.thisCurse.videoUrlTeacher && this.thisCurse.videoUrlTeacher != '') {
            this.isShowVeidoTech = true
            this.currName = '1-6'
            if(!this.thisCurse.videoUrlTeacher2 && !this.thisCurse.videoUrlTeacher3){
            this.videoNameTeacher = "教师视频"
            }else{
              this.videoNameTeacher = this.thisCurse.videoNameTeacher.split(".")[0]
            }
          } else {
            this.isShowVeidoTech = false
          }
          if (
            this.thisCurse.videoUrlTeacher2 &&
            this.thisCurse.videoUrlTeacher2 != ""
          ) {
            this.isShowVeidoTech2 = true;
            this.currName = "1-61";
            this.videoNameTeacher2 = this.thisCurse.videoNameTeacher2.split(".")[0]
          } else {
            this.isShowVeidoTech2 = false;
          }

          if (
            this.thisCurse.videoUrlTeacher3 &&
            this.thisCurse.videoUrlTeacher3 != ""
          ) {
            this.isShowVeidoTech3 = true;
            this.currName = "1-63";
            this.videoNameTeacher3 = this.thisCurse.videoNameTeacher3.split(".")[0]
          } else {
            this.isShowVeidoTech3 = false;
          }

          if (this.thisCurse.workOrderUrl && this.thisCurse.workOrderUrl != '') {
            this.isShowWorkOrder = true
            this.currName = '1-3'
          } else {
            this.isShowWorkOrder = false
          }

          if (this.thisCurse.teachingPlanUrl && this.thisCurse.teachingPlanUrl != '') {
            this.isShowTeachPlan = true
            this.currName = '1-2'
          } else {
            this.isShowTeachPlan = false
          }

          if (this.thisCurse.coursewareUrl && this.thisCurse.coursewareUrl != '') {
            this.isShowCourseWare = true
            this.currName = '1-1'
          } else {
            this.isShowCourseWare = false
          }
          //下载附件
          if (this.thisCurse.attachmentUrl && this.thisCurse.attachmentUrl != '') {
            this.isShowAttachment = true
            this.attachmentUrl = this.thisCurse.attachmentUrl
          } else {
            this.isShowAttachment = false
          }
          // if (this.courseType === 1) {
          this.HandleMenuSelect(this.currName)
          // }
          this.materialUrl = this.thisCurse.materialUrl
          this.exMaterialUrl = this.thisCurse.exMaterialUrl
          this.syMaterialUrl = this.thisCurse.syMaterialUrl
          // this.RenwudanPdfUrl = "showPDF?ossPath=" + this.thisCurse.workOrderUrl;
        }
      }
      let userInfo = JSON.parse(window.localStorage.getItem('userInfo'))
      ;(this.createrName = userInfo.realName), (this.createBy = userInfo.userId)
      ;(this.createrName = userInfo.realName),
        // (this.createBy = userInfo.id);

        //老师和校长可以打印
        // this.showPrint = (userInfo.userType == 1 || userInfo.userType == 0) ? true : false;

        //20200520在李亚妮的要求下修改为可以打印
        (this.showPrint = true)
    },

    printSc() {
      this.toFullScreen(3)
    },
    printJa() {
      var date = (new Date()).getTime()
      var ifr = document.createElement('iframe')
      ifr.style.frameborder = 'no'
      ifr.style.display = 'none'
      ifr.style.pageBreakBefore = 'always'
      ifr.setAttribute('id', 'printPdf' + date)
      ifr.setAttribute('name', 'printPdf' + date)
      ifr.src = window.URL.createObjectURL(this.fileBack)
      document.body.appendChild(ifr)
      this.doPrint('printPdf' + date)
      window.URL.revokeObjectURL(ifr.src) // 释放URL 对象
      // var ifwind = document.getElementById('iframe2').contentWindow
      // ifwind.print()
    },
    doPrint(val) {
      var ordonnance = document.getElementById(val).contentWindow
      setTimeout(() => {
        // window.print()
        ordonnance.print()
        this.pdfLoading = false
      }, 100)
    },
    async HandleMenuSelect(itemName) {
      if (itemName === '1-5') {
        if (this.$refs.playerStu) {
          this.$refs.playerStu.pause()
        }
        if (this.$refs.player) {
          this.$refs.player.pause()
        }
         if (this.$refs.player2) {
          this.$refs.player2.pause()
        }
         if (this.$refs.player3) {
          this.$refs.player3.pause()
        }
        return
      }
      this.currName = itemName

      if (itemName === '1-1') {
        this.isShowJiaoan = false
        this.isShowKejian = true
        this.currentPage = 1
        if (this.$refs.playerStu) {
          this.$refs.playerStu.pause()
        }
        if (this.$refs.player) {
          this.$refs.player.pause()
        }
                 if (this.$refs.player2) {
          this.$refs.player2.pause()
        }
         if (this.$refs.player3) {
          this.$refs.player3.pause()
        }
        this.loading = true
        let res = await blobRequest('/v3/upload/downLoadPrivateFile', { key: this.thisCurse.coursewareUrl }, false)
        this.loading = false
        let fileBack = new Blob([res], { type: 'application/pdf' })
        this.KejianPdfUrl = window.URL.createObjectURL(fileBack)
      }
      if (itemName === '1-2') {
        this.isShowJiaoan = true
        this.isShowKejian = false
        if (this.$refs.playerStu) {
          this.$refs.playerStu.pause()
        }
        if (this.$refs.player) {
          this.$refs.player.pause()
        }
                 if (this.$refs.player2) {
          this.$refs.player2.pause()
        }
         if (this.$refs.player3) {
          this.$refs.player3.pause()
        }
        this.loading = true
        let res = await blobRequest('/v3/upload/downLoadPrivateFile', { key: this.thisCurse.teachingPlanUrl }, false)
        let fileBack = new Blob([res], { type: 'application/pdf' })
        this.fileBack = fileBack
        let pdfUrl = window.URL.createObjectURL(fileBack)
        this.jiaoanPdf2 = pdfUrl
        if (pdfUrl !== '') {
          let loadingTask = PDF.createLoadingTask(pdfUrl)
          loadingTask.promise.then(pdf => {
            this.JiaoannumPages = pdf.numPages
            this.JiaoanPdfUrl = loadingTask
          })
        }
        this.loading = false
      }
      if (itemName === '1-3') {
        if (this.$refs.playerStu) {
          this.$refs.playerStu.pause()
        }
        if (this.$refs.player) {
          this.$refs.player.pause()
        }
                 if (this.$refs.player2) {
          this.$refs.player2.pause()
        }
         if (this.$refs.player3) {
          this.$refs.player3.pause()
        }
        this.RenwudanPdfUrl = this.thisCurse.workOrderUrl
      }
      if (itemName === '1-4') {
        if (this.$refs.playerStu) {
          this.$refs.playerStu.pause()
        }
        if (this.$refs.player) {
          this.$refs.player.pause()
        }
                 if (this.$refs.player2) {
          this.$refs.player2.pause()
        }
         if (this.$refs.player3) {
          this.$refs.player3.pause()
        }
        if (!this.VedioHavedLoad) {
          if (this.thisCurse.videoUrlStudent && this.thisCurse.videoUrlStudent !== '') {
            this.stuVideoUrL = this.thisCurse.videoUrlStudent
            this.VedioHavedLoad = false
          }
          // console.log(this.stuVideoUrL, "this.stuVideoUrL");
        }
      }
      if (itemName === '1-6') {
        if (this.$refs.playerStu) {
          this.$refs.playerStu.pause()
        }
        if (this.$refs.player) {
          this.$refs.player.pause()
        }
                 if (this.$refs.player2) {
          this.$refs.player2.pause()
        }
         if (this.$refs.player3) {
          this.$refs.player3.pause()
        }
        // console.log(this.thisCurse.videoUrlTeacher, "0", this.VedioHavedLoad);
        if (!this.VedioHavedLoad) {
          // console.log(this.thisCurse.videoUrlTeacher, "1");
          if (this.thisCurse.videoUrlTeacher && this.thisCurse.videoUrlTeacher !== '') {
            let res1 = await postRequest(`/v3/upload/getVideoPlayAuth/${this.thisCurse.videoUrlTeacher}`, {}, false)
            this.vidTech = this.thisCurse.videoUrlTeacher
            this.playauthTech = res1.result.PlayAuth
            this.coverTech = res1.result.CoverURL
            if (this.$refs.player) {
              this.$refs.player.reloadPlayer()
            }
            this.VedioHavedLoad = false
          }
        }
      }
      if (itemName === "1-61") {
              debugger
        if(this.$refs.playerStu){
          this.$refs.playerStu.pause()
        }
        if (this.$refs.player) {
          this.$refs.player.pause();
        }
        if (this.$refs.player3) {
          this.$refs.player3.pause();
        }
        
        // console.log(this.thisCurse.videoUrlTeacher, "0", this.VedioHavedLoad);
        if (!this.VedioHavedLoad) {
          // console.log(this.thisCurse.videoUrlTeacher, "1");
          if (this.thisCurse.videoUrlTeacher2 && this.thisCurse.videoUrlTeacher2 !== '') {
            let res1 = await postRequest(`/v3/upload/getVideoPlayAuth/${this.thisCurse.videoUrlTeacher2}`, {}, false)
            this.vidTech = this.thisCurse.videoUrlTeacher2
            this.playauthTech = res1.result.PlayAuth
            this.coverTech = res1.result.CoverURL
            if (this.$refs.player2) {
              this.$refs.player2.reloadPlayer()
            }
            this.VedioHavedLoad = false
          }
        }
      }
      if (itemName === "1-62") {
        debugger
        if(this.$refs.playerStu){
          this.$refs.playerStu.pause()
        }
        if (this.$refs.player) {
          this.$refs.player.pause();
        }
        if (this.$refs.player2) {
          this.$refs.player2.pause();
        }
        this.$refs.player3.pause();
         if (!this.VedioHavedLoad) {
          // console.log(this.thisCurse.videoUrlTeacher, "1");
          if (this.thisCurse.videoUrlTeacher3 && this.thisCurse.videoUrlTeacher3 !== '') {
            let res1 = await postRequest(`/v3/upload/getVideoPlayAuth/${this.thisCurse.videoUrlTeacher3}`, {}, false)
            this.vidTech = this.thisCurse.videoUrlTeacher3
            this.playauthTech = res1.result.PlayAuth
            this.coverTech = res1.result.CoverURL
            if (this.$refs.player3) {
              this.$refs.player3.reloadPlayer()
            }
            this.VedioHavedLoad = fals
          }
        }
      }
      if (itemName === '1-7') {
        if (this.$refs.player) {
          this.$refs.player.pause()
        }
        this.showInteraction = true
        this._getMyInteract()
      }
    },
    // 互动视频--------------------------
    // 查看全部任务
    async toShowTask() {
      this.showTask = true
      if (!this.interactiveVideoId) return
      const res = await postRequest('/v3/platform/interact/getMyInteract', { imId: this.interactiveVideoId }, false)
      if (!res.success) return
      this.interactList = res.result.myMaterialStruct
      this.finished = res.result.finish
    },
    closeDrawer() {
      this.showTask = false
    },
    // 获取列表
    async _getMyInteract() {
      if (!this.interactiveVideoId) return
      const res = await postRequest('/v3/platform/interact/getMyInteract', { imId: this.interactiveVideoId }, false)
      if (!res.success) return
      this.interactList = res.result.myMaterialStruct
      this.finished = res.result.finish
      // this.idx=this.interactList.findIndex(item=>item.id===res.result.currentInteract.id)
      this.currentInteract = res.result.currentInteract
      this.jugleType(res.result.currentInteract.materialType, res.result.currentInteract.info)
    },
    // 获取下一个详情
    async getMyMaterialById() {
      const index = this.interactList.findIndex(item => item.id == this.currentInteract.id)
      if (this.interactList[index + 1].id) {
        let nextId = this.interactList[index + 1].id
        const res = await postRequest('/v3/platform/interact/getMyMaterialById', { id: nextId }, false)
        if (res.success) {
          // this.idx=this.interactList.findIndex(item=>item.id===res.result.currentInteract.id)
          this.currentInteract = res.result.currentInteract
          this.noNext = res.result.noNext
          this.jugleType(res.result.currentInteract.materialType, res.result.currentInteract.info)
        }
      }
    },
    // 查看闯关成功的项
    async toDetail(item) {
      if (item.finish) {
        //为1闯关成功，可以点击查看
        const res = await postRequest('/v3/platform/interact/getMyMaterialById', { id: item.id }, false)
        if (res.success) {
          // this.idx=this.interactList.findIndex(item=>item.id===res.result.currentInteract.id)
          this.currentInteract = res.result.currentInteract
          this.noNext = res.result.noNext
          this.jugleType(res.result.currentInteract.materialType, res.result.currentInteract.info)
        }
      }
    },
    // 判断挑战类型
    jugleType(type, info) {
      switch (type) {
        case 'scratch':
          this.showScratch = true
          this.showAliplayer = false
          this.showExam = false
          this.ossPath = info.ossPath
          break
        case 'vedio':
          this.vid = info.vid
          this._playAuth(this.vid)
          // setTimeout(()=>{//解决播放空白bug
          // this.showScratch=false
          // this.showAliplayer=true
          // this.showExam=false
          // },500)
          break
        case 'exam':
          this.singleAnwer = ''
          this.multipleAnswer = []
          this.jugleAnwer = ''
          this.showScratch = false
          this.showAliplayer = false
          this.showExam = true
          this.examInfo = info
          if (this.examInfo.examType) {
            this.examTitText(this.examInfo.examType)
          }
          break
      }
    },
    // 动态显示体型titil
    examTitText(type) {
      switch (type) {
        case 'single':
          this.examTitType = '单选题'
          break
        case 'multiple':
          this.examTitType = '多选题'
          break
        case 'judge':
          this.examTitType = '判断题'
          break
      }
    },
    // 提交习题答案
    async submit(id, type) {
      this.submitLoading = true
      let answer
      if (type === 'multiple') {
        answer = this.multipleAnswer.sort().join('')
      } else if (type === 'single') {
        answer = this.singleAnwer
      } else {
        answer = this.jugleAnswer
      }
      const res = await postRequest('/v3/platform/interact/confirmExamAnswer', { id: id, answer: answer }, false)
      this.submitLoading = false
      if (res.success && res.result.correct) {
        this._handleSuccess()
      } else {
        this.$Message.error('答案不正确，请重试~')
      }
    },
    // 播放视频
    async _playAuth(vid) {
      this.showExam = false
      this.showScratch = false
      let res1 = await postRequest(`/v3/upload/getVideoPlayAuth/${vid}`, null, false)
      this.playauth = res1.result.PlayAuth
      this.cover = res1.result.CoverURL
      this.showAliplayer = true
      setTimeout(() => {
        this.$refs.playerInteraction.reloadPlayer()
      }, 500)
    },
    // 监听结束
    endedPlayer() {
      this.passMyInteract()
    },
    // scratch和习题闯关成功
    _handleSuccess() {
      if (!this.successModal) {
        this.successModal = true
        setTimeout(() => {
          this.successModal = false
          this.passMyInteract()
        }, 4000)
      }
    },
    // 闯关成功后调用
    async passMyInteract() {
      if (this.currentInteract.finish === 1) {
        if (this.noNext !== 1) {
          this.getMyMaterialById()
        }
      } else {
        const res = await postRequest('/v3/platform/interact/passMyInteract', { id: this.currentInteract.id }, false)
        if (res.success && this.noNext !== 1) {
          let intercct = this.interactList.find(item => item.id == this.currentInteract.id)
          intercct.finish = 1
          this.getMyMaterialById()
        }
      }
      if (this.noNext === 1) {
        this.overModal = true
        // setTimeout(()=>{
        //   this.back()
        // },3000)
      }
    }
  },
  mounted() {
    this.init()
    window.addEventListener('keydown', e => {
      if (e.keyCode == 37) {
        this.prevPage()
      }
    })
    window.addEventListener('keydown', e => {
      if (e.keyCode == 39) {
        this.nextPage()
      }
    })
    window['$vue'] = this
    window.addEventListener('message', this.events.receiveMessageFromParent, false)
    // this._getMyInteract()
  },
  beforeMount() {},
  created() {},
  beforeDestroy() {
    window.removeEventListener('message', this.events.receiveMessageFromParent, false)
  }
}
</script>

<style lang="less" scoped>
#iframe1,
#iframe2,
#iframe3 {
  height: 760px;
}
#main {
  background-color: #333333;
}
.theone {
  /*background-color: #212121;*/
  margin-top: 30px;
}
.pdf {
  position: relative;
  background-color: #555555;
  height: 760px;
  .scale {
    position: absolute;
    bottom: 0;
    right: 0;
    z-index: 9999;
    img {
      width: 36px;
      height: 36px;
      margin: 0 20px 20px 0;
      cursor: pointer;
    }
    img:nth-child(2) {
      margin-right: 30px;
    }
  }
  .leftButton {
    position: absolute;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
  }
  .rightButton {
    position: absolute;
    right: 27px;
    top: 50%;
    transform: translateY(-50%);
  }
}
.uploadModel1 {
  //text-align:center;
   position: fixed;  // 浮动
  z-index: 999999;
      /deep/ .ivu-modal-body {
        height: 800px;
        overflow: scroll;
    }
}
/deep/ .frame_body {
  /*width: 1481px;*/
  margin: 0 auto;
  /*height: 700px;*/
  border: none;
  & > .ivu-card-body {
    padding: 0;
    /*margin-top: 100px;*/
    background-color: #333333;
    & > {
      .ivu-layout {
        min-height: 700px;
        background-color: #333333;
      }
    }
    .ivu-layout-content {
      border-radius: 8px;
      padding: 0;
      /*margin-right: 30px;*/
      background-color: #555555;
      & > div {
        .blue {
          display: none;
        }
        .handle {
          height: 60px;
          width: 100%;
          background-color: #000000;
          display: flex;
          justify-content: space-between;
          align-items: center;
          color: #ffffff;
          & > div {
            display: flex;
            .goBack {
              width: 137px;
              height: 36px;
              text-align: center;
              line-height: 36px;
              font-size: 18px;
              background: rgba(51, 51, 51, 1);
              border-radius: 8px;
              margin: 0 20px 0 30px;
              cursor: pointer;
              span {
                margin-right: 15px;
              }
            }
            p {
              font-size: 20px;
            }
          }
          .fullScreen {
            margin-right: 30px;
            width: 100px;
            height: 30px;
            background-color: #35a7ff;
            border: 1px solid rgba(53, 167, 255, 1);
            border-radius: 6px;
            text-align: center;
            cursor: pointer;
            span {
              width: 100%;
              height: 100%;
              text-align: center;
              line-height: 30px;
            }
          }
          .handle_right {
            button {
              width: 100px;
              height: 30px;
              border-radius: 6px;
              margin-right: 20px;
              background-color: rgb(248, 126, 36);
              border: none;
              outline: none;
            }
          }
        }
        .frame_wrapper {
          background-color: #555555;
          padding: 0 125px;
          box-sizing: border-box;
          position: relative;
          & > img:nth-child(1) {
            position: absolute;
            top: 50%;
            left: 10px;
            transform: translateY(-50%);
            cursor: pointer;
          }
          & > img:nth-child(2) {
            position: absolute;
            top: 50%;
            right: 10px;
            transform: translateY(-50%);
            cursor: pointer;
          }
          & > div:nth-of-type(1) {
            // position: absolute;
            // right: 30px;
            // bottom: 30px;
            img {
              height: 36px;
              width: 36px;
              cursor: pointer;
            }
            img:nth-child(1) {
              margin-right: 20px;
            }
          }
          /*&>div:nth-of-type(2){*/
          /*    position: absolute;*/
          /*    left: 30px;*/
          /*    bottom: 30px;*/
          /*    color: #FFFFFF;*/
          /*}*/
        }
      }
    }
  }
  .right_slide {
    background-color: #555555;
    margin-left: 20px;
    box-sizing: border-box;
    padding-top: 20px;
    border-radius: 8px;
    position: relative;
    ul {
      background-color: #555555;
      color: #ffffff;
      .ivu-menu-item-active.ivu-menu-item-selected {
        color: #f87e24;
        background-color: #555555;
      }
      li {
        display: flex;
        align-items: center;
        img {
          width: 24px;
          height: 24px;
          margin-right: 28px;
        }
        a {
          color: #ffffff;
        }
      }
    }
    .appendix {
      position: absolute;
      bottom: 20%;
      left: 50%;
      cursor: pointer;
      transform: translateX(-50%);
      img {
        width: 130px;
        height: 34px;
      }
    }
  }
}
.blue {
  color: #40a9ff !important;
}
code {
  display: inline-block;
  background: #f7f7f7;
  font-family: Consolas, Monaco, Andale Mono, Ubuntu Mono, monospace;
  margin: 0 3px;
  padding: 1px 5px;
  border-radius: 3px;
  color: #666;
  border: 1px solid #eee;
}

// ==============================================
.allTaskBtn {
  position: absolute;
  top: 16px;
  right: 0;
  width: 120px;
  height: 50px;
  color: #fff;
  background-color: #ff8301;
  border-top-left-radius: 25px;
  border-bottom-left-radius: 25px;
  line-height: 50px;
  font-size: 20px;
  text-align: center;
  cursor: pointer;
  z-index: 1111;
}
.aaliplayr {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1000;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: hidden;
}
.uploadCodeModal {
  //position: relative;
  // /deep/ .ivu-drawer-body {
  //   overflow: visible;
  // }
  /deep/ .ivu-drawer-content {
    background-color: #fff;
  }
  // .backBtn {
  //   position: absolute;
  //   top: 20px;
  //   right: 50px;
  //   background-color: #fff;
  //   color: #ff8301;
  //   border: none;
  //   z-index: 999;
  //   border: 1px solid #c56602;
  //   font-size: 16px;
  // }
}
.noClickTitleName{
  font-size: 14px;
  color: #03081a;
  font-weight: 700;
}
.clickTitleName{
  color: #06a7ff;
  max-width: 120px;
  cursor: pointer;
  display: inline-block;
  vertical-align: middle;
  font-size: 14px;
}
.clickTitleNameSep{
      margin: 0 4px;
      height: 21px;
      line-height: 21px;
    color: #c4d8f4;
    display: inline-block;
    vertical-align: middle;
}
.fileItem{
  cursor: pointer;
  width:200px;height:200px;text-align: center;float: left;
  position: relative;
}
.fileDownloadBtn{
  position: absolute;
  display: none;
    top: 2px;
    right: 5px;
    font-size: 18px;
}
.fileItem:hover{
  background-color: #eee;
  cursor: pointer !important;
  .fileDownloadBtn{
    display: block;
  }
}
.details {
  width: 250px;
  display: block;
  position: absolute;
  background-color: #f5f5f5;
  padding: 10px;
  border-radius: 4px;
  text-align: left;
}
.fileItem:hover .details {
  cursor: pointer !important;
  display: block;
}
.fileName{
  margin-top: -10px;
  line-height: 18px;
  font-size: 12px;
  color: #03081a;
  overflow: hidden;
  max-height: 36px;
  word-break: break-all;
}
/deep/ .ivu-drawer-wrap {
  // position: relative!important;
  z-index: 9999 !important;
  // height: 96vh!important;
}
.ivu-timeline {
  margin-top: 70px;
}
/deep/ .ivu-drawer-header,
/deep/ .ivu-drawer-close {
  display: none;
}
/deep/ .ivu-drawer-content {
  background-color: #ff8301;
}
/deep/ .ivu-timeline-item-head {
  background-color: #fecd99;
  border: none;
}
/deep/ .ivu-timeline-item-tail {
  border-color: #ce6900;
  top: 40px;
}
/deep/ .ivu-timeline-item {
  display: flex;
  align-items: center;
}
/deep/ .ivu-timeline-item-content {
  padding: 8px 10px 8px 30px;
}

/deep/ .ivu-timeline-item-head-custom {
  background-color: transparent;
}
.closeDrawer {
  position: absolute;
  top: 20px;
  left: 0;
  width: 60px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-size: 16px;
  background-color: #fff;
  border-radius: 0 20px 20px 0;
  border: 1px solid #c56602;
  border-left: none;
  color: #ff8301;
  cursor: pointer;
}
.videoPro {
  display: flex;
  align-items: center;
  height: 60px;
  width: 300px;
  background-color: #fff;
  color: #333;
  border-radius: 5px;
  line-height: 60px;
  font-size: 20px;
  // padding: 0 20px;
  cursor: pointer;
  overflow: hidden;
  .leftIcon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 62px;
    height: 100%;
    border-radius: 0 50% 50% 0;
    // border: 2px solid #fff;
    background-color: #fec202;
    margin-right: 20px;
    img {
      width: 30px;
    }
  }
  .scratchIcon {
    background-color: #f2571e;
  }
  .examIcon {
    background-color: #1665e5;
  }
  .taskName {
    width: 215px;
    height: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
.grayIcon {
  background-color: #de984b !important;
}
.gray {
  background-color: #ce6900;
}

.scratchIframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
}
.previewExercises {
  margin: 0 auto;
  width: 100%;
  .exerciseTil {
    margin-bottom: 20px;
    // height: 40px;
    // line-height: 40px;
    background-color: #fff3de;
    padding: 10px 50px;
  }
  .single,
  .multiple {
    /deep/ .ivu-radio-wrapper {
      display: flex;
      margin: 10px 0;
      height: auto;
      span:nth-child(2) {
        display: inline-flex;
      }
      .ivu-radio {
        margin-top: 8px;
      }
    }
  }
  .jugle {
    .ivu-radio-wrapper {
      display: flex;
      align-items: center;
      margin: 10px 0;
    }
  }
  /deep/ .ivu-checkbox-group {
    display: flex;
    flex-direction: column;
  }
  /deep/ .ivu-checkbox-inner {
    border-radius: 50%;
    margin-right: 10px;
  }
  /deep/ .ivu-checkbox-group-item {
    display: inline-flex;
    align-items: center;
    margin: 10px 0;
  }
}

.examMoadal {
  /deep/ .ivu-modal-header {
    text-align: center;
    .ivu-modal-header-inner {
      color: #ffa000 !important;
      font-size: 24px;
      height: 40px;
      line-height: 40px;
    }
  }
  /deep/ .ivu-modal-content {
    border-radius: 20px;
    padding-bottom: 40px;
  }
  /deep/ .ivu-modal-footer {
    margin-top: 30px;
    div {
      width: 390px;
      margin: 0 auto;
      .ivu-btn {
        width: 390px;
        height: 50px;
        text-align: center;
        border-radius: 25px;
        border: 1px solid #ffa000;
        color: #ffa000;
        font-size: 18px;
      }
    }
  }
  /deep/ .ivu-modal-close {
    display: none;
  }
  /deep/ .ivu-modal-header,
  /deep/ .ivu-modal-footer {
    border: none;
  }
  /deep/ .ivu-modal-body {
    padding: 0;
  }
}
.successModal {
  /deep/ .ivu-modal-content {
    background-color: transparent;
    box-shadow: none;
    img {
      width: 500px;
      height: auto;
    }
  }
  /deep/ .ivu-modal-header,
  /deep/ .ivu-modal-close,
  /deep/ .ivu-modal-footer {
    display: none;
  }
}
.drawerModal {
  position: relative;
  /deep/ .ivu-drawer-body {
    overflow: visible;
  }
  .backBtn {
    position: absolute;
    bottom: 0.5rem;
    left: -1.2rem;
    background-color: #ff8301;
    color: #fff;
    border: none;
    z-index: 999;
  }
}
/deep/ .ivu-timeline {
  height: 100%;
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/views/teacher/showCourse.vue